export { default } from './ProductScreenshot'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/ProductScreenshot/index.js